<mat-form-field appearance="outline" style="width: 100%">
    <mat-label>{{ props.label }}</mat-label>
    <input matInput *ngIf="props.readonly" [formControl]="formControl" [formlyAttributes]="field"
        [required]="props.required" [readonly]="true" [panelClass]="props.panelClass || ''" />
    <mat-select *ngIf="!props.readonly" [formControl]="formControl" [formlyAttributes]="field"
        [required]="props.required" [panelClass]="props.panelClass || ''" (selectionChange)="onSelectionChange($event)">
        <mat-option style="background-color: white;">
            <ngx-mat-select-search [formControl]="filterCtrl" [placeholderLabel]="props.searchPlaceholder || 'Search'"
                [noEntriesFoundLabel]="props.noEntriesFoundLabel || 'No matches found'" />
        </mat-option>
        <!-- "Add New" Label with Search Text -->
        <!-- This option only shows if the user has typed something and it's not in the results -->
        <mat-option *ngIf="props.allowNewLabel && filterCtrl.value && !isOptionExist"
            (click)="addNew(filterCtrl.value)">
            Add "{{ filterCtrl.value }}" as new option
        </mat-option>
        <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.value">
            {{ option.label }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="formControl.invalid && formControl.touched">
        <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error>
</mat-form-field>